import { Field, useFormikContext } from 'formik';
import Address from 'src/components/util/Address';
import MuiValidTextField from 'src/components/util/MuiValidTextField';
import Section from 'src/components/util/Section';
import Subheader from 'src/components/util/Subheader';
import ADDRESS_FIELD_PROPS from 'src/data/propertyInfo/addressFieldNames';

export default function PersonalPropertyInfo() {
  const form = useFormikContext();

  return (
    <Section title="Personal Property Information">
      <Field
        InputLabelProps={{ shrink: true }}
        component={MuiValidTextField}
        label="Personal Property Account Number"
        name="info.accountNo"
        onChange={(e) => {
          form.setFieldValue('info.accountNo', e.target.value);
        }}
        type="number"
      />
      <Field
        InputLabelProps={{ shrink: true }}
        component={MuiValidTextField}
        label="Type of Property"
        name="info.type"
        onChange={(e) => {
          form.setFieldValue('info.type', e.target.value);
        }}
        type="text"
      />
      <Subheader>Location or Address of Subject Property</Subheader>
      <Address fieldNames={ADDRESS_FIELD_PROPS} />
    </Section>
  );
}
